module.exports = function(app) {
  'use strict';

  	app
  	.factory('config', configFactory);

  var config = {
    name: 'dashboard',
    title: 'Eklinika - dashboard',
    version: '1.0.5',
    refreshTokenInterval: 45,
    baseHref: 'http://eklinika.telegraf.rs/',
    baseMediaHref:'https://xdn.eklinika.rs/',
    baseElasticSearchHref:'https://pretraga.telegraf.rs/eklinika_posts/',
    // baseElasticLogsHref:'http://igit.comtrade.com:9200/logs/user/_search?sort=uts:desc',
    baseElasticLogsHref:window.settings+'logs?sort=uts:desc',
    videoUploadVersion: "v1.0",
    debug: true,
    /**
     * In-app constants
     */
    limitCharacterMin:0,
    limitCharacter:Infinity,
    shared_contents : {},
    rootMarginLazy : "0px 0px 250px 0px",
    lockingManager: {},
    focus_lock: {},
    'setConfig': function(data, type) {
      if(type=='init') {
        config.baseMediaHref = data.global.cdn;
        config.baseVideoHref = data.global.cdntv;
        config.refreshTokenInterval = data.global.refreshTokenInterval;
        config.baseHref = data.global.www;
        config.baseHrefVideo = data.global.wwwtv;
        config.baseElasticSearchHref = data.global.searchUrl;
        config.thumbs = data.thumbs;
        config.apiUrl =  data.global.url;
        config.heartbeat = data.global.heartbeat;
        config.www_biznis = data.global.www_biznis;
        config.videoUploadVersion = data.global.videoUploadVersion;
        config.videoUploadUrl = data.global.videoUploadUrl;
        config.socketUrl = data.global.controllab;
        config.mediaoutcast = data.mediaoutcast;
      }
      if(data.embed && type=='init') {
        config.embed = data.embed
      }
      if(data.scriptVersions && (type=='init' || type=='dashboard')) {
        config.www_script_version = data.scriptVersions.www_script_version;
      }
      if(data.focus && data.focus.minimum_number_items && type == 'init') {
        config.focus_minimum_number_items = data.focus.minimum_number_items
      }
      if(data.focus && data.focus.locked_order && type == 'init') {
        config.focus_blic_order = data.focus.locked_order.blic
        config.focus_eklinika_api_order = data.focus.locked_order.eklinika_api
        if(data.focus.locked_order.pr && data.focus.locked_order.pr.length>0) {
          config.focus_pr_order = data.focus.locked_order.pr
        }
        if(data.focus.locked_order.microsites && data.focus.locked_order.microsites.length>0) {
          config.focus_microsites_order = data.focus.locked_order.microsites
        } else {
          config.focus_microsites_order = []
        }
      }
      if(type == 'init' || type == 'focus_stream') {
        if(data.focus && data.focus.lock && Object.keys(data.focus.lock).length>0) {
          for (var key in data.focus.lock) {
            config.focus_lock[key] = data.focus.lock[key]
          }
        } else {
          // Clear focus_lock object
          for (var key in config.focus_lock) {
            if (Object.prototype.hasOwnProperty.call(config.focus_lock, key)) {
              delete config.focus_lock[key];
            }
          }
        }
      }
      if(data.lockingManager && type == 'init') {
        config.lockingManager = data.lockingManager
      }
      if(type == 'init') {
        config.newsServices = ['agencies','earthquakes', 'newshub']
        config.getHighlightWords = function(highlightWords) {
          config.highlightWordsDiacritics = [];
          config.highlightWordsBase = []
          config.highlightWordsActive = false;
          if(highlightWords){ 
            if(highlightWords.active) {
              config.highlightWordsActive = true;
            }
            if(highlightWords.words && highlightWords.words.length > 0) {
              config.highlightWordsBase = highlightWords.words
              if(highlightWords.active) {
                highlightWords.words.forEach(function(item) {
                  config.highlightWordsDiacritics.push((getVariationsPattern(item)))
                })
              }
            }
          }
        }
        config.getHighlightWords(data.highlightWords)
        function getVariationsPattern(word) {
          var variations = '';
          for (var i = 0; i < word.length; i++) {
            var char = word[i];
            var charVariations = getVariations(char);
            variations += charVariations;
          }
          return escapeRegExp(variations);
        }
        function escapeRegExp(string) {
          return string.replace(/[$.']/g, '\\$&');
        }


        // Function to generate variations of a character
        function getVariations(char) {
          switch (char) {
            case 'Č':
                return '[ČC]';
            case 'č':
                return '[čc]';
            case 'Ć':
                return '[ĆC]';
            case 'ć':
                return '[ćc]';
            case 'Š':
                return '[ŠS]';
            case 'š':
                return '[šs]';
            case 'Ž':
                return '[ŽZ]';
            case 'ž':
                return '[žz]';
            // Add more cases for other characters and their variations
            default:
                return char;
          }
        }
      }
    },
    settings: {
      colors: {
        'white': '#fff',
        'black': '#000',
        'gray-light': '#999',
        'gray-lighter': '#eee',
        'gray': '#666',
        'gray-dark': '#343434',
        'gray-darker': '#222',
        'gray-semi-light': '#777',
        'gray-semi-lighter': '#ddd',
        'brand-primary': '#5d8fc2',
        'brand-success': '#64bd63',
        'brand-warning': '#f0b518',
        'brand-danger': '#dd5826',
        'brand-info': '#5dc4bf'
      },
      screens: {
        'xs-max': 767,
        'sm-min': 768,
        'sm-max': 991,
        'md-min': 992,
        'md-max': 1199,
        'lg-min': 1200
      },
      navCollapseTimeout: 2500
    },
    addSafety : [
        {
            _id:'babysafe',
            label:'Babysafe'
        },
        {
            _id:'safe',
            label:'Safe'
        },
        {
            _id:'semisafe',
            label:'Semisafe'
        },
        {
            _id:'unsafe',
            label: 'Unsafe'
        }
    ],
    geoRestrictions: [
        {
            _id:'ww',
            label:'Worldwide'
        },
        {
            _id:'ex-yu',
            label:'Ex-Yu'
        },
        {
            _id:'exyu-no-si',
            label:'Ex-Yu  Without Slovenia'
        },
        {
            _id:'exyu-no-si-hr',
            label:'Ex-Yu Without Slovenia&Croatia'
        },
        {
            _id:'rs-me',
            label:'Serbia and Montenegro'
        },
        {
            _id:'rs',
            label:'Serbia'
        }
    ],
    numberFocusItems:19,
    // thumbs: [
    //   {
    //     'width': 50,
    //     'height':50
    //   },{
    //     'width': 70,
    //     'height':70
    //   },{
    //     'width': 140,
    //     'height':90
    //   },
    //   {
    //     'width': 180,
    //     'height':120
    //   },
    //   {
    //     'width': 300,
    //     'height':170
    //   },
    //   {
    //     'width': 300,
    //     'height':250
    //   },
    //   {
    //     'width': 350,
    //     'height':170
    //   },
    //   {
    //     'width': 670,
    //     'height':447
    //   },
    //   {
    //     'width': 830,
    //     'height':553
    //   }
    // ],
    state: {
      'nav-static': false
    },
    aiTools:[
      {
        name:'Title suggestion',
        funcionality: 'title-suggestion',
        stripHtml: 'all',
        multiple: false,
        editor: false,
        displayType: 'block',
        displayTypeObj: false,
      },
      {
        name:'Page title suggestion',
        funcionality: 'page-title-suggestion',
        stripHtml: 'all',
        multiple: false,
        editor: false,
        displayType: 'block',
        displayTypeObj: false,
      },
      {
        name:'Tags suggestion',
        funcionality: 'tags-suggestion',
        stripHtml: 'all',
        multiple: true,
        editor: false,
        displayType: 'inline',
        displayTypeObj: true,
      },
      {
        name:'Text summary',
        funcionality: 'text-summary',
        stripHtml: 'all', 
        multiple: false,
        editor: true,
        displayType: 'block',
        displayTypeObj: false,
        twoColumns: false,
      },
      {
        name:'Text expansion',
        funcionality: 'text-expansion',
        stripHtml: 'replace-shortcodes',
        multiple: false,
        editor: true,
        displayType: 'block',
        displayTypeObj: false,
        twoColumns: true,
      },
      {
        name:'Text reformulation',
        funcionality: 'text-reformulation',
        stripHtml: 'replace-shortcodes',
        multiple: false,
        editor: true,
        displayType: 'block',
        displayTypeObj: false,
        twoColumns: true,
      },
      { 
        name:'Text correction', 
        funcionality: 'text-correction',
        stripHtml: 'replace-shortcodes',
        multiple: false,
        editor: true,
        displayType: 'block',
        displayTypeObj: false,
        twoColumns: true,
        diffText: true,
      }
    ],
    aiEditorsTools:[{
        name:'Expansion',
        funcionality:'text-expansion',
      },
      {
        name:'Reformulation',
        funcionality:'text-reformulation',
      },
      {
        name:'Correction',
        funcionality:'text-correction',
      },
      {
        name:'Summary',
        funcionality:'text-summary',
      }      
    ]
  };
 
  configFactory.$inject = [];
  function configFactory() {
    // return {
    //    'setConfig': function(data) {
    //     config.baseMediaHref = data.global.cdn;
    //     config.refreshTokenInterval = data.global.refreshTokenInterval;
    //     config.baseHref='http://www.telegraf.rs/';
    //     config.baseElasticSearchHref = data.global.searchUrl;
    //     config.thumbs = data.thumbs;
    //    } 
    // }
   return config
    // var Helpers = function(){
    //   this._initResizeEvent();
    //   this._initOnScreenSizeCallbacks();
    // };
    // Helpers.prototype = {
    //   _resizeCallbacks: [],
    //   _screenSizeCallbacks: {
    //     xs:{enter:[], exit:[]},
    //     sm:{enter:[], exit:[]},
    //     md:{enter:[], exit:[]},
    //     lg:{enter:[], exit:[]}
    //   },

    //   /**
    //    * Checks screen size according to Bootstrap default sizes
    //    * @param size screen size  ('xs','sm','md','lg')
    //    * @returns {boolean} whether screen is <code>size</code>
    //    */
    //   isScreen: function(size){
    //     var screenPx = $window.innerWidth;
    //     return (screenPx >= config.settings.screens[size + '-min'] || size === 'xs') && (screenPx <= config.settings.screens[size + '-max'] || size === 'lg');
    //   },

    //   /**
    //    * Returns screen size Bootstrap-like string ('xs','sm','md','lg')
    //    * @returns {string}
    //    */
    //   getScreenSize: function(){
    //     var screenPx = $window.innerWidth;
    //     if (screenPx <= config.settings.screens['xs-max']) return 'xs';
    //     if ((screenPx >= config.settings.screens['sm-min']) && (screenPx <= config.settings.screens['sm-max'])) return 'sm';
    //     if ((screenPx >= config.settings.screens['md-min']) && (screenPx <= config.settings.screens['md-max'])) return 'md';
    //     if (screenPx >= config.settings.screens['lg-min']) return 'lg';
    //   },

    //   /**
    //    * Specify a function to execute when window entered/exited particular size.
    //    * @param size ('xs','sm','md','lg')
    //    * @param fn callback(newScreenSize, prevScreenSize)
    //    * @param onEnter whether to run a callback when screen enters `size` or exits. true by default @optional
    //    */
    //   onScreenSize: function(size, fn, /**Boolean=*/ onEnter){
    //     onEnter = typeof onEnter !== 'undefined' ? onEnter : true;
    //     this._screenSizeCallbacks[size][onEnter ? 'enter' : 'exit'].push(fn)
    //   },

    //   /**
    //    * Change color brightness
    //    * @param color
    //    * @param ratio
    //    * @param darker
    //    * @returns {string}
    //    */
    //   //credit http://stackoverflow.com/questions/1507931/generate-lighter-darker-color-in-css-using-javascript
    //   changeColor: function(color, ratio, darker) {
    //     var pad = function(num, totalChars) {
    //       var pad = '0';
    //       num = num + '';
    //       while (num.length < totalChars) {
    //         num = pad + num;
    //       }
    //       return num;
    //     };
    //     // Trim trailing/leading whitespace
    //     color = color.replace(/^\s*|\s*$/, '');

    //     // Expand three-digit hex
    //     color = color.replace(
    //       /^#?([a-f0-9])([a-f0-9])([a-f0-9])$/i,
    //       '#$1$1$2$2$3$3'
    //     );

    //     // Calculate ratio
    //     var difference = Math.round(ratio * 256) * (darker ? -1 : 1),
    //     // Determine if input is RGB(A)
    //       rgb = color.match(new RegExp('^rgba?\\(\\s*' +
    //         '(\\d|[1-9]\\d|1\\d{2}|2[0-4][0-9]|25[0-5])' +
    //         '\\s*,\\s*' +
    //         '(\\d|[1-9]\\d|1\\d{2}|2[0-4][0-9]|25[0-5])' +
    //         '\\s*,\\s*' +
    //         '(\\d|[1-9]\\d|1\\d{2}|2[0-4][0-9]|25[0-5])' +
    //         '(?:\\s*,\\s*' +
    //         '(0|1|0?\\.\\d+))?' +
    //         '\\s*\\)$'
    //         , 'i')),
    //       alpha = !!rgb && rgb[4] !== null ? rgb[4] : null,

    //     // Convert hex to decimal
    //       decimal = !!rgb? [rgb[1], rgb[2], rgb[3]] : color.replace(
    //         /^#?([a-f0-9][a-f0-9])([a-f0-9][a-f0-9])([a-f0-9][a-f0-9])/i,
    //         function() {
    //           return parseInt(arguments[1], 16) + ',' +
    //             parseInt(arguments[2], 16) + ',' +
    //             parseInt(arguments[3], 16);
    //         }
    //       ).split(/,/);

    //     // Return RGB(A)
    //     return !!rgb ?
    //     'rgb' + (alpha !== null ? 'a' : '') + '(' +
    //     Math[darker ? 'max' : 'min'](
    //       parseInt(decimal[0], 10) + difference, darker ? 0 : 255
    //     ) + ', ' +
    //     Math[darker ? 'max' : 'min'](
    //       parseInt(decimal[1], 10) + difference, darker ? 0 : 255
    //     ) + ', ' +
    //     Math[darker ? 'max' : 'min'](
    //       parseInt(decimal[2], 10) + difference, darker ? 0 : 255
    //     ) +
    //     (alpha !== null ? ', ' + alpha : '') +
    //     ')' :
    //       // Return hex
    //       [
    //         '#',
    //         pad(Math[darker ? 'max' : 'min'](
    //           parseInt(decimal[0], 10) + difference, darker ? 0 : 255
    //         ).toString(16), 2),
    //         pad(Math[darker ? 'max' : 'min'](
    //           parseInt(decimal[1], 10) + difference, darker ? 0 : 255
    //         ).toString(16), 2),
    //         pad(Math[darker ? 'max' : 'min'](
    //           parseInt(decimal[2], 10) + difference, darker ? 0 : 255
    //         ).toString(16), 2)
    //       ].join('');
    //   },
    //   lightenColor: function(color, ratio) {
    //     return this.changeColor(color, ratio, false);
    //   },
    //   darkenColor: function(color, ratio) {
    //     return this.changeColor(color, ratio, true);
    //   },

    //   max: function(array) {
    //     return Math.max.apply(null, array);
    //   },

    //   min: function(array) {
    //     return Math.min.apply(null, array);
    //   },

    //   /**
    //    * Triggers sn:resize event. sn:resize is a convenient way to handle both window resize event and
    //    * sidebar state change.
    //    * Fired maximum once in 100 millis
    //    * @private
    //    */
    //   _initResizeEvent: function(){
    //     var resizeTimeout;

    //     jQuery($window).on('resize', function() {
    //       $timeout.cancel(resizeTimeout);
    //       resizeTimeout = $timeout(function(){
    //         jQuery($window).trigger('sn:resize');
    //       }, 100);
    //     });
    //   },

    //   /**
    //    * Initiates an array of throttle onScreenSize callbacks.
    //    * @private
    //    */
    //   _initOnScreenSizeCallbacks: function(){
    //     var resizeTimeout,
    //       helpers = this,
    //       prevSize = this.getScreenSize();

    //     jQuery($window).resize(function() {
    //       $timeout.cancel(resizeTimeout);
    //       resizeTimeout = $timeout(function(){
    //         var size = helpers.getScreenSize();
    //         if (size !== prevSize){ //run only if something changed
    //           //run exit callbacks first
    //           helpers._screenSizeCallbacks[prevSize]['exit'].forEach(function(fn){
    //             fn(size, prevSize);
    //           });
    //           //run enter callbacks then
    //           helpers._screenSizeCallbacks[size]['enter'].forEach(function(fn){
    //             fn(size, prevSize);
    //           });
    //           $log.log('screen changed. new: ' + size + ', old: ' + prevSize);
    //         }
    //         prevSize = size;
    //       }, 100);
    //     });
    //   }
    // };

  
    // config.helpers = new Helpers();
    
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/config.js
// module id = 426
// module chunks = 0